export default (tipo, datos) => {
  let f = require('./' + tipo + '.ticket.js').default;

  return f(datos);
};
